module.exports = __webpack_public_path__ + "media/images/shark/Josh-p-500-a4d1f292a32967e38a6973a332b9d569.jpeg";